import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import estimateProvider from "@/providers/estimate.provider";

const START_XACTIMATE_PHOTO_UPLOAD_KEY = ["xactimateExport", "startPhotoUpload"] as const;

export interface StartXactimatePhotoUploadParams {
  estimateId: string;
  transactionId: string;
}

export function useStartXactimatePhotoUploadMutation() {
  return useMutation({
    mutationKey: START_XACTIMATE_PHOTO_UPLOAD_KEY,
    mutationFn: async ({ estimateId, transactionId }: StartXactimatePhotoUploadParams) => {
      const { status } = await estimateProvider.startXactimatePhotoUpload({ estimateId, transactionId });
      return status;
    },
    onSuccess: (status) => {
      if (status !== "uploading") return;
      toast.dismiss();
      toast.info("Uploading photos in background…", {
        className: "!text-blue-500 !bg-blue-500/10 !border-blue-500",
      });
    },
    onError: (error) => {
      console.error("Failed to start Xactimate photo upload:", error);
    },
  });
}
